import * as changeCase from ".";

describe("change case", () => {
  it("exports expected methods", () => {
    expect(typeof changeCase).toEqual("object");
  });
});
